import {AppPermissions} from '@shared/constants/Mapping';
import useTicketingSystemPermission from '../../TicketingSystem/hooks/useTicketingSystemPermission';

type IPriorAuthPermission = typeof AppPermissions.PRIOR_AUTHORIZATION;
interface IUsePriorAuthPermissionProps {
  objectFunction: Exclude<keyof IPriorAuthPermission, 'NAME'>;
}
const usePriorAuthPermission = (
  props: IUsePriorAuthPermissionProps = {
    objectFunction: 'LIST'
  }
): boolean => {
  const {objectFunction} = props;
  return useTicketingSystemPermission({
    module: 'PRIOR_AUTHORIZATION',
    objectFunction,
    groupPermission: 'PRIOR_AUTHORIZATION_ENABLE'
  });
};

export default usePriorAuthPermission;
